import { createAsyncThunk } from '@reduxjs/toolkit';
import { postApi, putApi } from 'redux/apis';

interface GetEmployeesListParams {
    companyId: string;
    status: string;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
    page?: number;
    limit?: number;
}

interface UpdateEmployeeStatusParams {
    companyId: string;
    employeeId: string;
    isActiveInApp: boolean;
}

// ENG-363 (Item 4 + Item 8): edit an employee's name and/or in-app active status.
// Both fields are optional; at least one must be provided. companyId is carried
// for symmetry with the other thunks but is NOT sent in the body — the backend
// derives it from the URL employee id (checkCompanyMembership).
interface UpdateEmployeeParams {
    companyId: string;
    employeeId: string;
    fullName?: string;
    isActiveInApp?: boolean;
}

export const getEmployeesListAction = createAsyncThunk(
    'employeesTable/getList',
    async (params: GetEmployeesListParams, { rejectWithValue }) => {
        try {
            const { companyId, status, search, sortBy, sortOrder, page, limit } =
                params;

            const body = {
                companyId,
                status,
            };

            const queryParams: any = {};
            if (search) queryParams.search = search;
            if (sortBy) queryParams.sortBy = sortBy;
            if (sortOrder) queryParams.sortOrder = sortOrder;
            if (page) queryParams.page = page;
            if (limit) queryParams.limit = limit;

            const response = await postApi('/employees/list', body, false, queryParams);

            console.log('response get employees list', response);

            return {
                responseData: response.data.data,
                isPagination: (page || 1) > 1,
            };
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateEmployeeStatusAction = createAsyncThunk(
    'employeesTable/updateStatus',
    async (params: UpdateEmployeeStatusParams, { rejectWithValue }) => {
        try {
            const response = await postApi('/employees/update-status', params);

            console.log('response update', response);

            return {
                updatedEmployee: response.data.data,
                message: response.data.message,
            };
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const updateEmployeeAction = createAsyncThunk(
    'employeesTable/updateEmployee',
    async (params: UpdateEmployeeParams, { rejectWithValue }) => {
        try {
            const { employeeId, fullName, isActiveInApp } = params;

            const body: { fullName?: string; isActiveInApp?: boolean } = {};
            if (fullName !== undefined) body.fullName = fullName;
            if (isActiveInApp !== undefined) body.isActiveInApp = isActiveInApp;

            const response = await putApi(`/employees/${employeeId}`, body);

            return {
                employee: response.data.data.employee,
                payPeriod: response.data.data.payPeriod,
                message: response.data.message,
            };
        } catch (error: any) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

